import { render, staticRenderFns } from "./UserDashboardDeliveryCardFooter.vue?vue&type=template&id=764fed7a&"
import script from "./UserDashboardDeliveryCardFooter.vue?vue&type=script&lang=js&"
export * from "./UserDashboardDeliveryCardFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports